<template>
<div style="padding:20px;box-sizing:border-box">
      <el-form ref="form" :model="form" label-width="100px" :label-position="labelPosition">
           <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="岗位类别">
                        <el-select v-model="form.gangWei" placeholder="请选择"  @change="edit_gw">
                            <el-option :label="item.gangwei" :value="item.id" v-for="item in gangWei" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="姓名">
                        <el-input v-model="form.name" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="地点">
                        <el-input v-model="form.zhiWei" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
           </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="作品链接">
                        <el-input v-model="form.links" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                 <el-col :span="8">
                    <el-form-item label="标签">
                        <el-select v-model="form.region_desc" multiple  placeholder="请选择">
                            <el-option :label="item.labelc" :value="item.id" v-for="item in BQ" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
           </el-row>
         <el-form-item label="上榜人照片">
            <el-upload action="https://hmd.18durensheng.com/admin_upload/filesupload.html"  :file-list="fileList" list-type="picture-card" :on-success="upload_cg" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"> 
                <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
        <el-form-item label="推荐人/推荐理由">
            <el-input type="textarea" v-model="form.descs" class="textares" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <el-form-item label="评审">
            <el-button type="primary" @click="add_pf()" style="margin-top:0px;">添加</el-button>
            <el-link  :underline="false"  style="margin-left:50px;">评分结果 {{form.avg}}</el-link>
            <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="290px">
                <el-table-column   label="沟通能力">
                    <template slot-scope="scope">
                         <el-select v-model="scope.row.hangye" class="select2" placeholder="select" size="mini" @change="edit">
                            <el-option key="0" label="0" value="0"></el-option>
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                            <el-option key="5" label="5" value="5"></el-option>
                        </el-select>
                     </template>
                </el-table-column>
                <el-table-column   label="创意能力">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.xingjiabi" class="select2" placeholder="select" size="mini" @change="edit">
                            <el-option key="0" label="0" value="0"></el-option>
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                            <el-option key="5" label="5" value="5"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column   label="项目投入度">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.koucai" class="select2" placeholder="select" size="mini" @change="edit">
                            <el-option key="0" label="0" value="0"></el-option>
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                            <el-option key="5" label="5" value="5"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="price"  label="时间观念" >
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.zuopin" class="select2" placeholder="select" size="mini" @change="edit">
                            <el-option key="0" label="0" value="0"></el-option>
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                            <el-option key="5" label="5" value="5"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="num"  label="制作配合度" >
                     <template slot-scope="scope">
                          <el-select v-model="scope.row.qita" class="select2" placeholder="select" size="mini" @change="edit">
                              <el-option key="0" label="0" value="0"></el-option>
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                            <el-option key="5" label="5" value="5"></el-option>
                        </el-select>
                     </template>
                </el-table-column>
                 <el-table-column prop="username"  label="评审人" v-if="idx==2"></el-table-column>
                <el-table-column label="操作" >
                   <template slot-scope="scope">
                        <el-link :underline="false" type="danger" @click="del(scope.$index, tableData)" size="small">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-form-item>
        <el-form-item style="text-align:center;margin-top:0px;">
            <el-button type="primary" @click="onSubmit" v-if="idx==1">确认添加</el-button>
            <el-button type="primary" @click="onEdit" v-if="idx==2 || idx==3">确认修改</el-button>
            <el-button @click="qx">取消</el-button>
        </el-form-item>
    </el-form>
</div>
  
</template>
<script>
import {gangwei,getBQ,getList_add,getList_detal,getList_edit} from '@/utils/api'

  export default {
    data() {
      return {
        labelPosition:'left',
        dialogImageUrl: '',
        dialogVisible: false,
        form: {
          gangWei: '',
          gwId:'',
          name:'',
          zhiWei:'',
          links:'',
          regionId:'',
          region_desc: '',
          img:[],
          descs: '',
          avg:0
        },
        tableData: [
            {
                hangye:'',
                xingjibi:'',
                koucai:'',
                zuopin:'',
                qita:'',
                num:'',
            }
        ],
        user:{},
        gangWei:[],
        BQ:[],
        idx:0,
        lid:'',
        fileList:[]
      }
    },
    methods: {
        edit_gw(){
            this.form.gwId=this.form.gangWei;
        },
        onSubmit(){
            this.form.gwId=this.form.gangWei;
            this.form.regionId=this.form.region_desc;
            getList_add({userId:this.user.uid,forms:this.form,tableData:this.tableData}).then(res=>{
                this.$router.push({
                    path:'/Warehousing'
                })
            });
        },
        onEdit(){
            getList_edit({userId:this.user.uid,forms:this.form,tableData:this.tableData}).then(res=>{
                if(this.idx==2){
                    this.$router.push({
                        path:'/Warehousing'
                    })
                }else if(this.idx==3){
                    this.$router.push({
                        path:'/Warehouse'
                    })
                }
                
            });
        },
        upload_cg(file,fileList){
            this.form.img.push({name:file.name,url:file.file_url})
            console.log(this.form.img)
        },
        handleRemove(file, fileList) {
            this.form.img=fileList
            var newImg=[]
            this.form.img.forEach(function(v){
                newImg.push({name:v.name,url:v.url})
            })
            this.form.img=newImg
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        edit(){
            var aa=0
            // if(this.tableData.length>=5){
                this.tableData.forEach(function(v){
                 console.log(v)
                 aa=Number(aa)+(Number(v.hangye)+Number(v.xingjiabi)+Number(v.koucai)+Number(v.zuopin)+Number(v.qita))
                
                })
                this.form.avg=(Number(aa/5/this.tableData.length))
            // }
            console.log(this.form.avg,'fenhu')
        
            //this.tableData[0].num=(Number(this.tableData[0].hangye)+Number(this.tableData[0].xingjibi)+Number(this.tableData[0].koucai)+Number(this.tableData[0].zuopin)+Number(this.tableData[0].qita))/5
        },
        qx(){
            console.log(this.idx)
             if(this.idx==2 || this.idx==1){
                this.$router.push({
                    path:'/Warehousing'
                })
            }else if(this.idx==3){
                this.$router.push({
                    path:'/Warehouse'
                })
            }
        },
        add_pf(){
            this.tableData.push({id:'',hangye:0,xingjiabi:0,koucai:0,zuopin:0,qita:0,username:this.user.name})
        },
        del(index, rows){
           rows.splice(index, 1);
           if(rows.length<5){
               this.form.avg=0
           }
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        this.idx=this.$route.query.idx
        this.lid=this.$route.query.id
        gangwei().then(res=>{
            this.gangWei=res;
        });
        getBQ().then(res=>{
            this.BQ=res;
        });
        if(this.idx==2 || this.idx==3){
            getList_detal({id:this.lid}).then(res=>{
                this.form=res.forms;
                this.tableData=res.tabledata;
                this.fileList= this.form.img
             var aas=[];
            this.form.img.forEach(function(v){
                aas.push({name:v.name,url:v.url})
            })
            this.form.img=aas;
            });
        }
       
    }
  }
</script>
<style scoped>
    .inpt{
        width:240px;
    }
    .textares{
        width:400px;
    }
    .textares>textarea{
        height: 218px !important;
        width:300px;;overflow-y: hidden
    }
    
</style>


// WEBPACK FOOTER //
// src/components/NameList.vue